// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let CalendarDate = require("../../../reason/common/types/CalendarDate.bs.js");
let AttributeListV5 = require("../../cap/Property/components/AttributeListV5.bs.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let JsxRuntime = require("react/jsx-runtime");
let FragmentErrorBoundary = require("../ErrorHandling/FragmentErrorBoundary.bs.js");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let RentalPropertyLease_rentalProperty_graphql = require("../../../__generated__/RentalPropertyLease_rentalProperty_graphql.bs.js");

let convertFragment = RentalPropertyLease_rentalProperty_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, RentalPropertyLease_rentalProperty_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(RentalPropertyLease_rentalProperty_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, RentalPropertyLease_rentalProperty_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(RentalPropertyLease_rentalProperty_graphql.node, convertFragment, fRef);
}

let PropertyFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function RentalPropertyLease$DisplayAttributes(props) {
  return JsxRuntime.jsx(AttributeListV5.make, {
    data: [
      {
        title: props.leaseLengthDisplayName + ` lease`
      },
      {
        title: `From ` + CalendarDate.format(props.availableFrom)
      }
    ],
    size: props.size
  });
}

let DisplayAttributes = {
  make: RentalPropertyLease$DisplayAttributes
};

function RentalPropertyLease$WithoutErrorBoundary(props) {
  let match = RescriptRelay_Fragment.useFragment(RentalPropertyLease_rentalProperty_graphql.node, convertFragment, props.property);
  return JsxRuntime.jsx(RentalPropertyLease$DisplayAttributes, {
    leaseLengthDisplayName: match.leaseLength.displayName,
    availableFrom: match.availableFrom,
    size: props.size
  });
}

let WithoutErrorBoundary = {
  make: RentalPropertyLease$WithoutErrorBoundary
};

function RentalPropertyLease(props) {
  return JsxRuntime.jsx(FragmentErrorBoundary.make, {
    fragmentDisplayName: "lease details",
    children: JsxRuntime.jsx(RentalPropertyLease$WithoutErrorBoundary, {
      property: props.property,
      size: props.size
    })
  });
}

let make = RentalPropertyLease;

exports.PropertyFragment = PropertyFragment;
exports.DisplayAttributes = DisplayAttributes;
exports.WithoutErrorBoundary = WithoutErrorBoundary;
exports.make = make;
/* CalendarDate Not a pure module */
